// extracted by mini-css-extract-plugin
export default {"root":"Ao8mXCJnbnj6sDWYer5b"};